import { render, staticRenderFns } from "./ImageObjectCreateForm.vue?vue&type=template&id=814a8480&scoped=true&"
import script from "./ImageObjectCreateForm.vue?vue&type=script&lang=ts&"
export * from "./ImageObjectCreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./ImageObjectCreateForm.vue?vue&type=style&index=0&id=814a8480&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814a8480",
  null
  
)

export default component.exports